<template>
  <portal to="body">
    <div
      class="m-overlay ml-modal"
      v-if="visible || show_override"
    >
      <!-- backdrop area -->
      <div
        class="m-scroll"
        :class="{ full: size === 'full' }"
        @mousedown.self="onBackdropDown"
        @mouseup.self="onBackdropUp"
      >
        <div
          class="m-container"
          :class="{ full: size === 'full' }"
          :style="calculated_style"
          @click.stop
        >
          <div class="m-header">
            <slot name="header" />
            <button class="m-close" @click="close_clicked">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="m-content">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  name: 'MemlistModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'lg', // Default size is 'lg'
      validator: v => ['sm', 'md', 'lg', 'xl','xxl','xxxl','full'].includes(v) // Valid sizes: sm, md, lg
    }
  },
  emits: ['close'],
  data() {
    return {
      show_override: false,
      backdropPressed: false,     // remember where the press started
    };
  },

  methods: {
    /* programmatic control ------------------------------------------------ */
    show()  { this.show_override = true },
    hide()  { this.show_override = false },

    /* backdrop gesture ---------------------------------------------------- */
    onBackdropDown (e) {
      if (!this.isOnScrollbar(e)) this.backdropPressed = true;
    },
    onBackdropUp (e) {
      if (this.backdropPressed && !this.isOnScrollbar(e)) {
        this.close_clicked();
      }
      this.backdropPressed = false;
    },

    isOnScrollbar (e) {
      const el = e.currentTarget;          //  == .m-scroll
      const vertical   = el.scrollHeight > el.clientHeight &&
                        e.offsetX > el.clientWidth;     // in the bar zone?
      const horizontal = el.scrollWidth  > el.clientWidth &&
                        e.offsetY > el.clientHeight;
      return vertical || horizontal;
    },

    /* common close path --------------------------------------------------- */
    close_clicked() {
      this.show_override = false;
      this.$emit('close');
    },
  },
  computed: {
    calculated_style() {
      const style = {
        'background-color': this.theme === 'dark' ? 'rgb(33, 34, 45)' : 'white',
      }

      switch (this.size) {
        case 'sm':   style['width'] = '320px'; break;
        case 'lg':   style['width'] = '640px'; break;
        case 'xl':   style['width'] = '1024px'; break;
        case 'xxl':  style['width'] = '1360px'; break;
        case 'xxxl': style['width'] = '1600px'; break;
        case 'full':
          style['width'] = '100%';
          style['height'] = '100%';
          break;
      }

      return style;
    }
  }
}
</script>

<style scoped>
.m-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 999;
  /*  overflow removed – backdrop never scrolls  */
}

.m-scroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.m-scroll.full {
  overflow: hidden;
  align-items: stretch;
}

.m-container {
  margin-top: 32px;
  position: relative;
  background: #fff;
  border-radius: 8px;
  padding: 1em;
  padding-top: 2.8em;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

.m-container.full {
  margin-top: 0 !important;
  height: 100% !important;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
}

.m-close {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  line-height: 1;
}

.m-content {
  margin-top: 2em;
}

.m-close {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background-color: rgba(128, 128, 128, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.m-close i {
  font-size: 16px;
  color: #333;
}

.m-close:hover {
  background-color: rgba(128, 128, 128, 0.4);
}

.m-close:active {
  transform: scale(0.95);
}

.m-header {
  position: absolute;
  top: 0.5em;
  left: 1em;
  right: 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  pointer-events: none; /* prevent slot content from blocking close button */
}

.m-header > * {
  pointer-events: auto;
}

</style>
